import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import ReviewStars from "../ReviewStars";
import { TextQuoteButton } from "./TextQuoteButton";
import { useContent } from "../../lib/content";

const AREA_LINKS = { "rocky mount": "/rocky-mount-nc", tarboro: "/tarboro-nc", wilson: "/wilson-nc", nashville: "/nashville-nc", "red oak": "/red-oak-nc", "spring hope": "/spring-hope-nc", bailey: "/bailey-nc", zebulon: "/zebulon-nc", raleigh: "/raleigh-nc" };

export const OfferReviews = () => {
  const c = useContent();
  return (
  <section data-testid="offer-reviews" className="section-pad bg-[#f5f8ff] tex-grid-light">
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
      <div className="lg:sticky lg:top-28">
        <span className="eyebrow">Reviews</span>
        <ReviewStars className="mt-4" starClass="w-6 h-6" />
        <h2 className="mt-6 text-3xl md:text-4xl font-extrabold text-[#0a1f44]">{c.reviews.heading}</h2>
        <p className="mt-4 text-lg text-slate-600 leading-relaxed">{c.reviews.text}</p>
      </div>
      <div data-testid="offer-areas" className="rounded-3xl bg-white border border-slate-200 p-8">
        <p className="font-bold text-[#0a1f44]">{c.areas.text}</p>
        <div className="mt-5 flex flex-wrap gap-2">
          {c.areas.towns.map((n) => {
            const to = AREA_LINKS[n.trim().toLowerCase()];
            const inner = <><MapPin className="w-3.5 h-3.5 text-[#3b9dff]" />{n}</>;
            const cls = "inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-slate-200 text-sm font-semibold text-[#0a1f44] hover:border-[#3b9dff] transition-colors";
            return to ? <Link key={n} to={to} data-testid={`offer-area-${to.slice(1)}`} className={cls}>{inner}</Link> : <span key={n} className={cls}>{inner}</span>;
          })}
        </div>
      </div>
    </div>
  </section>
  );
};

export const FinalCta = () => {
  const { finalCta: f } = useContent();
  return (
  <section data-testid="final-cta" className="section-pad bg-gradient-to-br from-[#3b9dff] via-[#2b8ae8] to-[#1f6fd1] tex-grid-dark overflow-hidden">
    <div className="max-w-[1000px] mx-auto px-5 lg:px-8 text-center">
      <h2 className="text-3xl md:text-5xl font-extrabold text-white">{f.heading}</h2>
      <TextQuoteButton dark testId="final-text-quote-btn" label={f.buttonLabel} className="mt-8" />
    </div>
  </section>
  );
};
